"use client";
import React from "react";
import HeroPage from "./components/HeroPage";
import { View } from "./ListingPage1";
import { findPropertiesByType } from "../../constants/mockProperties";
import HeroSearch from "./components/HeroSearch";
import Breadcrumbs from "./components/BreadCrumb";
import { UnitsResponse } from "src/app/lib/useFetchUnits";
const Rent1 = () => {
  // Fetch units with default params

  return (
    <section className="max-w-full overflow-clip">
      <HeroPage
        subHeader="Your next move starts here-browse, find, and secure your perfect property today!"
        header="Property For Sale "
      />
      <HeroSearch />
      <div className="py-4  wrapper">
        <Breadcrumbs />
      </div>
      <View
        placeholder={{} as unknown as UnitsResponse}
        text="We’re currently updating our listings of properties for sale to offer you the latest and most desirable options on the market. Whether you're seeking a residential home, commercial space, or a strategic investment, we’ll soon have listings that match your goals.New properties are being added - check back shortly!"
        type="sale"
        properties={[
          ...findPropertiesByType("sale"),
          ...findPropertiesByType("sale"),
          ...findPropertiesByType("sale"),
          ...findPropertiesByType("sale"),
        ]}
      />
    </section>
  );
};
export default Rent1;
